// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FilterFunctor from "../../../../../../../library/filter-module/filter-view-template/FilterFunctor.bs.js";
import * as FilterPartnerConfig from "./FilterPartnerConfig.bs.js";

var PartnerFilterComponent = FilterFunctor.T(FilterPartnerConfig.T);

function FilterPartnerComponent(Props) {
  var params = Props.params;
  return React.createElement(PartnerFilterComponent.make, {
              params: params
            });
}

var make = FilterPartnerComponent;

export {
  PartnerFilterComponent ,
  make ,
  
}
/* PartnerFilterComponent Not a pure module */
